module.exports = "<div>\r\n  <div id=\"screen-disable\"></div>\r\n  <div id=\"loader\"></div>\r\n  <router-outlet></router-outlet>\r\n  <div (click)=\"showTeamEasterEgg()\" style=\"height: 10px; width: 10px;\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = app